// extracted by mini-css-extract-plugin
module.exports = {"Container":"DateTime_Container__tvfno","Date":"DateTime_Date__31A0V","Time":"DateTime_Time__3jX6-","Title":"DateTime_Title__yeOcB"};